import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core"
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, horizontalListSortingStrategy } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

function SortableChip({ id }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })
  const style = { transform: CSS.Transform.toString(transform), transition }
  return (
    <span
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="px-3 py-1.5 rounded-full border border-border bg-card text-xs cursor-grab active:cursor-grabbing capitalize"
    >
      {id}
    </span>
  )
}

export function SortableWidgets({ order, onReorder }) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  )
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={(e) => {
        const { active, over } = e
        if (!over || active.id === over.id) return
        const oldIndex = order.indexOf(active.id)
        const newIndex = order.indexOf(over.id)
        onReorder(arrayMove(order, oldIndex, newIndex))
      }}
    >
      <SortableContext items={order} strategy={horizontalListSortingStrategy}>
        <div className="mb-4 flex flex-wrap gap-2">
          {order.map((id) => (
            <SortableChip key={id} id={id} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  )
}
